import React from "react";
import { Card, Table, Typography } from "antd";
import styles from "./OperationRequestWorkspace.module.css";

const { Text } = Typography;

/**
 * @param {{ payments: Array<Record<string, unknown>> }} props
 */
export default function OperationRequestPaymentsCard({ payments }) {
  const payColumns = [
    { title: "סוג תשלום", dataIndex: "method", key: "method", ellipsis: true },
    {
      title: "סכום",
      key: "amount",
      width: 120,
      render: (_, row) =>
        row.amount != null && Number.isFinite(row.amount)
          ? `${row.amount} ${row.currency === "USD" ? "$" : row.currency === "ILS" ? "₪" : row.currency}`
          : "—",
    },
    { title: "תאריך", dataIndex: "paidAt", key: "paidAt", width: 110 },
    { title: "אסמכתא", dataIndex: "confirmation", key: "confirmation", ellipsis: true },
    { title: "סטטוס", dataIndex: "status", key: "status", width: 92 },
  ];

  return (
    <Card className={styles.sidebarCard} size="small" title="תשלומים קשורים">
      {!payments?.length ? (
        <Text type="secondary">לא נמצאו תשלומים</Text>
      ) : (
        <Table
          size="small"
          pagination={false}
          rowKey="key"
          columns={payColumns}
          dataSource={payments}
          scroll={{ x: true }}
        />
      )}
    </Card>
  );
}
